// extracted by mini-css-extract-plugin
module.exports = {"logoSelector":"VenueLogos_logoSelector__1DLfN"};